import { Component } from '@angular/core';
import { ToastModule } from 'primeng/toast';
import { NgClass } from '@angular/common';
import { ToastSeverity, toastKey } from '../../../../../models/enums';

@Component({
  selector: 'app-system-toast',
  standalone: true,
  imports: [ToastModule, NgClass],
  templateUrl: './system-toast.html',
  styleUrl: './system-toast.scss'
})
export class SystemToastComponent {
  protected readonly ToastSeverity = ToastSeverity;
  protected readonly toastKey = toastKey;
}
